import { EditProtectedAreaPage } from '@features/Property/ProtectedArea/EditProtectedAreaPage'
import { getPropertyDetailsQuery } from '@services/queryOptions'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/forestowner/$forestownerId/property/$propertyId/protected-area/edit',
)({
  component: RouteComponent,
  staticData: {
    breadcrumb: 'Rediger vernet areal',
  },
})

function RouteComponent() {
  const { propertyId } = Route.useParams()
  const { data, isLoading } = useQuery(getPropertyDetailsQuery(propertyId))

  if (isLoading) return <div>Laster...</div>
  if (!data) return null

  return <EditProtectedAreaPage properties={[data]} source="propertyDetails" />
}
